import React, { useEffect, useState } from 'react';
import useNavModel, { RouterParamType } from '@/model/navModel';
import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Pagination, Rate, Spin } from 'antd';
import { TablePaginationConfig } from 'antd/lib/table';
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants';
import { ISearchPage } from '@/types/AppTypes';
import { transPgToPagination } from '@/model/globalModel';
import { evaluateService } from '@/views/food/evaluate/evaluateService';
import moment from 'moment';

function ChefIntegral() {
    const { replaceNav, getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const initPgCfg: TablePaginationConfig = { pageSize: 5, current: 1 }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [loading, setLoading] = useState<any>({ spinning: false, tip: "数据加载中..." });
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [totalNum, setTotalNum] = useState<number>(0);

    useEffect(() => {
        detailsInfo && loadData()
    }, [detailsInfo])

    //列表查询
    const loadData = async (
        page: ISearchPage = initPgCfg,
    ) => {
        setLoading({ spinning: true, tip: "数据加载中..." });
        let { retData: totalData } = await evaluateService.cookTotal(detailsInfo.id);
        setTotalNum(totalData ?? 0)
        const searchParams = {
            cookId: detailsInfo.id,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await evaluateService.page(searchParams);
        let { data, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(data)
        setLoading({ spinning: false })
    };

    return (
        <Spin {...loading}>
            <div className='remark-container'>
                <div className="remark-head">
                    <div className='head-wrap'>
                        <div className='title'>厨师评分详情</div>
                        <div className='grade'>
                            综合评分：<Rate allowHalf value={Math.ceil(+(totalNum ?? 0))} className="remark-rate" disabled />
                            <span className='grade-color' style={{
                                verticalAlign: "middle",
                                marginLeft: '4px'
                            }}>{totalNum}分</span>
                        </div>
                    </div>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        size="small"
                        style={{ fontSize: "14px" }}
                        onClick={() => { replaceNav("6-2", "6") }}
                    >返回</Button>
                </div>
                <div className='remark-content'>
                    {dataSource && dataSource.map(item => (
                        <div className='remar-item' key={item.id}>
                            <div className='item-avatar'>
                                <Avatar icon={<UserOutlined />} size={38} />
                            </div>
                            <div className='item-detail'>
                                <div className='item-userinfo'>
                                    <span>{item.user?.name}</span>
                                    <span>{moment(item.updateTime).format("YYYY-MM-DD HH:mm:ss")}</span>
                                    <span className='grade-color'>评分+{item.grade}</span>
                                </div>
                                <Rate allowHalf value={item.grade} className="remark-rate" disabled />
                                <div className='item-desc'>
                                    {item.suggest ? <span>{item.suggest}</span> : <span style={{ color: "#999" }}>无评论内容！</span>}
                                </div>
                                <div className='item-assign'><span>评论了我的菜品：</span>{item.food?.name}</div>
                            </div>
                        </div>
                    ))}
                    {/* <div className='remar-item'>
                        <div className='item-avatar'>
                            <Avatar icon={<UserOutlined />} size={38} />
                        </div>
                        <div className='item-detail'>
                            <div className='item-userinfo'>
                                <span>姜丽丽</span>
                                <span>2022-02-14  15:30:21</span>
                                <span className='grade-color'>评分+2</span>
                            </div>
                            <Rate allowHalf defaultValue={2.5} className="remark-rate" />
                            <div className='item-desc'>这个菜品很好吃~这个菜品很好吃~这个菜品</div>
                            <div className='item-assign'><span>评论了我的菜品：</span>干煸豆角</div>
                        </div>
                    </div> */}
                </div>
                <div className='remark-pagination'>
                    {dataSource.length > 0 &&
                        <Pagination  {...{
                            ...pgCfg,
                            showTotal: () => `共${pgCfg.total ?? 0}条`,
                            onChange: (pageNum, pageSize) => {
                                loadData({ pageNum, pageSize })
                            }
                        }} />
                    }
                </div>
            </div>
        </Spin>
    );
}

export default ChefIntegral;
